function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M12.1.7L17.4 6A7.5 7.5 0 116.8 6L12.1.7z",
  stroke: "currentColor"
});

var SvgDroplet = function SvgDroplet(props) {
  return React.createElement("svg", _extends({
    width: 24,
    height: 23
  }, props), _ref);
};

export default SvgDroplet;